import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { StaticRouter } from 'react-router-dom';
import ConfigContext from './contexts/ConfigContext';
import Error500Page from './components/public/Error500Page';

import getStore from './redux/store';

function App({ data, railsContext }) {
  const { location } = railsContext;
  const store = getStore(data);
  const routes = require('./routes/routes').default;

  const config = useMemo(() => ({
    ...data.data.city_config,
    ...railsContext,
    url: railsContext.href,
    serverSide: true
  }), [data.data.city_config, railsContext]);

  return (
    <ConfigContext.Provider value={config}>
      <Provider store={store}>
        <StaticRouter location={location} context={{}}>
          <Sentry.ErrorBoundary fallback={<Error500Page />}>
            {routes}
          </Sentry.ErrorBoundary>
        </StaticRouter>
      </Provider>
    </ConfigContext.Provider>
  );
}

App.propTypes = {
  data: PropTypes.object,
  railsContext: PropTypes.object,
};

export default App;
